import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  IconButton,
  Tooltip,
} from "@mui/material";
import { getDisplayValue } from "../Utility/Utility"; // Ensure this is your utility function
import { showSmallLoadingImage ,showLoadingImage} from "../Utility/Utility"; // Ensure this is your utility function
const AddPaymentDialog = ({
  open,
  onClose,
  onSave,
  newPayment,
  patientId,
  setNewPayment,
  paymentModes = [],
  isSaving = false,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle sx={{ fontWeight: 600, fontSize: "20px" }}>
        Add New Payment
      </DialogTitle>
      <DialogContent dividers>
        <FormControl fullWidth margin="normal">
          <InputLabel>Payment Mode</InputLabel>
        <Select
  label="Payment Mode"
  value={newPayment.paymentMode}
  onChange={(e) =>
    setNewPayment({ ...newPayment, paymentMode: e.target.value })
  }
>
  {paymentModes.map((mode) => (
    <MenuItem key={mode.value} value={mode.value}>
      {mode.displayValue}
    </MenuItem>
  ))}
</Select>
        </FormControl>

        <TextField
          label="Amount"
          fullWidth
          margin="normal"
          type="number"
          value={newPayment.amount}
          onChange={(e) =>
            setNewPayment({
              ...newPayment,
              amount: parseFloat(e.target.value),
            })
          }
        />
        <TextField
          label="Received From"
          fullWidth
          margin="normal"
          value={newPayment.receivedFrom}
          onChange={(e) =>
            setNewPayment({ ...newPayment, receivedFrom: e.target.value })
          }
        />
        <TextField
          label="Notes"
          fullWidth
          multiline
          rows={3}
          value={newPayment.notes || ""}
          onChange={(e) =>
            setNewPayment({ ...newPayment, notes: e.target.value })
          }
        />
      </DialogContent>

      <DialogActions>
            <Button 
                  onClick={onClose}
                  variant="outlined" 
                  color="inherit"
                >
                  Close
                </Button>
                {isSaving && (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(216, 214, 214, 0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1301, // Above Dialog (zIndex 1300)
      }}
    >
      {showLoadingImage()}
    </div>
  )}

  {/* Save button always shows just "Save" */}
  <Button
    onClick={onSave}
    variant="contained"
    color="secondary"
    disabled={isSaving}
  >
    Save
  </Button>

      </DialogActions>
    </Dialog>
  );
};

export default AddPaymentDialog;